import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { RecordsRelated } from "../../components/recordsRelated/RecordsRelated";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { categoriesParentOptions } from "./categoriesParentOptions";
import { Groups } from "../../components/groups/Groups";
import { tabs } from "./categoriesParentTabs";
import { categoriesChildOptions } from "../processes-categories-child/categoriesChildOptions";

export const fieldsQuery = "*.*";

export const categoriesParentRoutes = [
  {
    path: "/processes_parent_category",
    element: <Records entity="processes_parent_category" fieldsQuery={fieldsQuery} />,
  },
  {
    path: "/processes_parent_category/:id",
    element: (
      <Record
        entity="processes_parent_category"
        type="detail"
        fieldsQuery={fieldsQuery}
        body={<DetailTabs tabs={tabs} />}
      />
    ),
    children: [
      {
        path: "/processes_parent_category/:id/detail",
        element: <Groups groupsOptions={categoriesParentOptions.groupsOptions} />,
      },
      {
        element: (
          <RecordsRelated
            entity="process_category"
            fieldsToQuery="*.*"
            fieldToFilter="process_parent_category"
            //heightOfHeaders={398}
            recordsOptions={categoriesChildOptions}
          />
        ),
        path: "/processes_parent_category/:id/process_category",
      },
    ],
  },
  {
    path: "/processes_parent_category/:id/update",
    element: (
      <Record
        entity="processes_parent_category"
        type="update"
        fieldsQuery={fieldsQuery}
        body={<EntityForm groupsOptions={categoriesParentOptions.groupsOptions} />}
      />
    ),
  },
  {
    path: "/processes_parent_category/create",
    element: (
      <Record
        entity="processes_parent_category"
        type="create"
        fieldsQuery={fieldsQuery}
        body={<EntityForm groupsOptions={categoriesParentOptions.groupsOptions} />}
      />
    ),
  },
];
